<template>
  <div class="com">
    <div class="input-wrap">
      <input
        v-mask="'XX - XX - XXX - XXXX'"
        id="kit-id"
        type="text"
        class="input"
        placeholder="Enter Kit ID"
        v-model="enterKit"
        @paste="paste"
        name="kit_id"
        :class="{ invalid: errors.has('kit_id') || errorCase }"
        v-validate="{ required: true, length: 20 }"
      />
      <span class="validate-error" v-if="errors.has('kit_id') && !errorCase">
        {{ setError(errors.first("kit_id")) }}
      </span>
      <span class="validate-error" v-else-if="errorCase == 'already_registered'">
        Kit is already activated, please
        <router-link to="/login" tag="a" class="login-link">sign in.</router-link>
      </span>
      <span class="validate-error" v-else-if="errorCase == 'archived'">
        This Kit ID has been archived. Please
        <a :href="contact_link" target="_blank" class="login-link">contact support.</a>
      </span>
      <span class="validate-error" v-else-if="errorCase == 'not_found'">
        This Kit ID does not exist. Please check and try again.
      </span>
    </div>
    <div class="input-wrap">
      <input
        v-mask="'XX - XX - XXX - XXXX'"
        id="kit-verify"
        type="text"
        class="input"
        @paste="paste"
        @change="validate"
        placeholder="Confirm Kit ID"
        v-model="verifyKit"
        name="confirm_kit_id"
        v-validate="{ required: true, is: enterKit }"
      />
      <span
        class="validate-error bottom-position"
        v-if="errors.has('confirm_kit_id')"
      >
        {{ errors.first("confirm_kit_id") }}
      </span>
    </div>
    <button
      class="btn"
      @click.prevent="$validator.validateAll()"
      @click="switchStep"
      :disabled="!isComplete"
    >
      Continue
    </button>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { parseAndConvertKitId } from "../../mixins/parseAndConvertKitId";

export default {
  name: "ActivateKir",
  mixins: [parseAndConvertKitId],
  directives: { mask },
  data() {
    return {
      verifyKit: null,
      enterKit: null,
      errorCase: false,
      contact_link: 'https://www.gotmold.com/#contact-us',
    };
  },
  computed: {
    ...mapGetters(["serverValidation"]),
    isComplete() {
      return (
        this.verifyKit && this.enterKit && this.verifyKit === this.enterKit
      );
    }
  },

  watch: {
    serverValidation(error) {
      error.forEach(item => {
        this.$validator.errors.add({ field: item.field, msg: item.message });
      });
      if (this.serverValidation.length > 0) {
        const msg = this.serverValidation[0].message;
        if (msg == 'exists validation failed on kit_id' || msg == 'existsInAny validation failed on kit_id' || msg == 'Kit not found' || msg == 'Kit ID does not exist') {
          this.errorCase = 'not_found';
        } else if (msg == 'Kit ID already registered. Sign in!') {
          this.errorCase = 'already_registered';
        } else if (msg == 'This Kit has been archived') {
          this.errorCase = 'archived';
        } else {
          this.errorCase = false;
        }
      } else {
        this.errorCase = false;
      }
    },
    verifyKit() {
      this.verifyKit = this.verifyKit.toUpperCase();
    },
    enterKit() {
      this.enterKit = this.enterKit.toUpperCase();
      this.errorCase = false;
      this.$validator.errors.remove('kit_id');
      if (this.verifyKit) {
        this.$nextTick(() => {
          this.$validator.validate('confirm_kit_id');
        });
      }
    }
  },
  methods: {
    setError(str) { 
      return str;
    },
    paste(e) {
      e.preventDefault();
    },
    validate() {
      this.$validator.validate('confirm_kit_id');
    },
    ...mapActions(["userInfo", "checkKitIdProfile"]),
    switchStep() {
      this.errorCase = false;
      this.$validator.errors.remove('kit_id');
      if (!this.isComplete) {
        return;
      }
      const kitId = {
        kit_id: this.parseKitId(this.enterKit),
        kit_id_confirmation: this.parseKitId(this.verifyKit)
      };
      this.checkKitIdProfile(kitId).then(res => {
          this.$emit("nextStep", 1);
          this.$emit("kitId", {'enterKit':this.parseKitId(this.enterKit),'verifyKit':this.parseKitId(this.verifyKit)});
      }).catch(() => {
        // Error is handled by serverValidation watcher via axios interceptor
      });
    }
  },
  mounted() {
    if (localStorage.getItem("actkitid")) {
      this.verifyKit = localStorage.getItem("actkitid");
      this.enterKit = localStorage.getItem("actkitid");
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}
.com {
  margin: 36px 0 0 0;
}
.input {
  padding: 17px 20px;
  border-radius: 10px;
  border: 1px solid #c5c5c5;
  color: $gray;
  width: 100%;
  font-size: 16px;
  text-align: center;
  text-transform: uppercase;
  outline: none;
  font-family: TTNormsMedium, sans-serif;
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
  text-align: center;
  text-transform: none;
  font-family: TTNormsMedium, sans-serif;
}
.input-wrap {
  margin: 0 0 20px;
  position: relative;
}
.input.invalid {
  border: 1px solid $red;
}
.bottom-position {
  bottom: -22px;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  transition: all 0.5s linear;
  font-size: 18px;
  font-family: TTNormsBold, sans-serif;
}
.login-link {
  color: #005eb8;
}
</style>
